import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BsEnvelope, BsWallet2 } from "react-icons/bs";
import { Link, useNavigate } from "react-router-dom";
import WalletConnectButton from "../../components/wallet-connect-button/WalletConnectButton";
import "./Home.css";

export default function Home() {
  const { keycloak, initialized } = useKeycloak();
  const navigate = useNavigate();
  const { t } = useTranslation(["home"]);

  const loginUrl = keycloak.createLoginUrl({
    redirectUri: `${window.location.origin}/dashboard`,
  });

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      navigate("/dashboard");
    }
  }, [keycloak.authenticated, initialized, navigate]);

  return (
    <div className="home-container bg-light">
      <div className="home-box shadow rounded bg-white">
        <h1>{t("heading", { ns: "home" })}</h1>
        <Link
          to={loginUrl}
          className="btn btn-success flex-centered w-100 mb-3"
        >
          {t("button.login_email", { ns: "home" })}
          <BsEnvelope className="ms-1" />
        </Link>
        <WalletConnectButton
          className="btn btn-success flex-centered w-100 mb-3"
          isLogin
        >
          {t("button.login_wallet", { ns: "home" })}
          <BsWallet2 className="ms-1" />
        </WalletConnectButton>
      </div>
    </div>
  );
}
